const has_all_right = state => state.user.userInfo.user_type === 3 && state.user.userInfo.rights.has_all_right === 0
const getters = {
  // token: state => state.user.token,
  // name: state => state.user.name,
  // roles: state => state.user.roles,
  // permission_routers: state => state.permission.routers,
  // addRouters: state => state.permission.addRouters
  // avatar: state => config.site + '/' + state.user.avatar,

  // 新增文件夹
  right__folder_tree: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['folder/tree']) {
      return state.user.userInfo.rights.api_list['folder/tree'].has_right
    }
    return 1;
  },
  // 申请上传地址
  right__file_number: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['file/{number}']) {
      return state.user.userInfo.rights.api_list['file/{number}'].has_right
    }
    return 1;
  },
  // 新建文档
  right__file_doc: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['file/doc']) {
      return state.user.userInfo.rights.api_list['file/doc'].has_right
    }
    return 1;
  },
  // 文件编辑
  right__edit_number: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['edit/{number}']) {
      return state.user.userInfo.rights.api_list['edit/{number}'].has_right
    }
    return 1;
  },
  // 移动/复制/删除/还原文件(夹)
  right__operationFileOrFolder: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['operationFileOrFolder']) {
      return state.user.userInfo.rights.api_list['operationFileOrFolder'].has_right
    }
    return 1;
  },
  // 重命名
  right__rename: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['rename']) {
      return state.user.userInfo.rights.api_list['rename'].has_right
    }
    return 1;
  },
  // 执行文件版本回退
  right__file_version_back_opera: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['file_version_back/opera']) {
      return state.user.userInfo.rights.api_list['file_version_back/opera'].has_right
    }
    return 1;
  },
  // 文件历史版本删除
  right__file_version_back_delete_back_version: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['file_version_back/delete_back_version']) {
      return state.user.userInfo.rights.api_list['file_version_back/delete_back_version'].has_right
    }
    return 1;
  },
  // 星标
  right__startag: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['startag']) {
      return state.user.userInfo.rights.api_list['startag'].has_right
    }
    return 1;
  },
  // 私人网盘容量扩容申请
  right__user_extend_capacity: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['user/extend/capacity']) {
      return state.user.userInfo.rights.api_list['user/extend/capacity'].has_right
    }
    return 1;
  },
  // 公共网盘容量扩容申请
  right__capacity_add_public_capacity: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['capacity/add_public_capacity']) {
      return state.user.userInfo.rights.api_list['capacity/add_public_capacity'].has_right
    }
    return 1;
  },
  // 创建/编辑群
  right__group: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group']) {
      return state.user.userInfo.rights.api_list['group'].has_right
    }
    return 1;
  },
  // 解散群
  right__groupCancel: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['groupCancel']) {
      return state.user.userInfo.rights.api_list['groupCancel'].has_right
    }
    return 1;
  },
  // 编辑群主页
  right__group_home_content: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group/home/content']) {
      return state.user.userInfo.rights.api_list['group/home/content'].has_right
    }
    return 1;
  },
  // 申请加入群
  right__groupApply: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['groupApply']) {
      return state.user.userInfo.rights.api_list['groupApply'].has_right
    }
    return 1;
  },
  // 审核入群申请
  right__group_requests: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group/requests']) {
      return state.user.userInfo.rights.api_list['group/requests'].has_right
    }
    return 1;
  },
  // 创建群角色
  right__group_role_create: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group_role/create']) {
      return state.user.userInfo.rights.api_list['group_role/create'].has_right
    }
    return 1;
  },
  // 编辑群角色
  right__group_role_edit: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group_role/edit']) {
      return state.user.userInfo.rights.api_list['group_role/edit'].has_right
    }
    return 1;
  },
  // 删除群角色
  right__group_role_delete: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group_role/delete']) {
      return state.user.userInfo.rights.api_list['group_role/delete'].has_right
    }
    return 1;
  },
  // 配置群角色用户
  right__group_role_member_edit: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group_role_member/edit']) {
      return state.user.userInfo.rights.api_list['group_role_member/edit'].has_right
    }
    return 1;
  },
  // 分配群目录权限给群用户
  right__group_resource_role_batch_grant_to_members: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group_resource_role/batch_grant_to_members']) {
      return state.user.userInfo.rights.api_list['group_resource_role/batch_grant_to_members'].has_right
    }
    return 1;
  },
  // 群成员身份管理
  right__groupMemberIdentity: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['groupMemberIdentity']) {
      return state.user.userInfo.rights.api_list['groupMemberIdentity'].has_right
    }
    return 1;
  },
  // 群资源保存至个人盘
  right__group_resource_savetocloud: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['group/resource/savetocloud']) {
      return state.user.userInfo.rights.api_list['group/resource/savetocloud'].has_right
    }
    return 1;
  },
  // 分享资源举报
  right__share_resource_report_create: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['share/resource/report/create']) {
      return state.user.userInfo.rights.api_list['share/resource/report/create'].has_right
    }
    return 1;
  },
  // 标签
  right__resource_tag: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['resource/tag']) {
      return state.user.userInfo.rights.api_list['resource/tag'].has_right
    }
    return 1;
  },
  // 删除消息
  right__message_delMessage: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['message/delMessage']) {
      return state.user.userInfo.rights.api_list['message/delMessage'].has_right
    }
    return 1;
  },
  // 创建群话题
  right__topic_create: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['topic/create']) {
      return state.user.userInfo.rights.api_list['topic/create'].has_right
    }
    return 1;
  },
  // 编辑群话题
  right__topic_edit: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['topic/edit']) {
      return state.user.userInfo.rights.api_list['topic/edit'].has_right
    }
    return 1;
  },
  // 删除话题
  right__topic_delete: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['topic/delete']) {
      return state.user.userInfo.rights.api_list['topic/delete'].has_right
    }
    return 1;
  },
  // 删除话题回复
  right__topic_comment_delete: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['topic/comment/delete']) {
      return state.user.userInfo.rights.api_list['topic/comment/delete'].has_right
    }
    return 1;
  },
  // 创建群话题回复
  right__topic_comment_create: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['topic/comment/create']) {
      return state.user.userInfo.rights.api_list['topic/comment/create'].has_right
    }
    return 1;
  },
  // 群话题举报
  right__topic_report_create: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['topic/report/create']) {
      return state.user.userInfo.rights.api_list['topic/report/create'].has_right
    }
    return 1;
  },
  // 创建分享
  right__share_create: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['share/create']) {
      return state.user.userInfo.rights.api_list['share/create'].has_right
    }
    return 1;
  },
  // 编辑分享
  right__share_edit: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['share/edit']) {
      return state.user.userInfo.rights.api_list['share/edit'].has_right
    }
    return 1;
  },
  // 删除分享
  right__share_delete: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['share/delete']) {
      return state.user.userInfo.rights.api_list['share/delete'].has_right
    }
    return 1;
  },
  // 移除分享
  right__share_remove: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['share/remove']) {
      return state.user.userInfo.rights.api_list['share/remove'].has_right
    }
    return 1;
  },
  // 将分享资源保存至我的网盘
  right__share_saveResource: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['share/saveResource']) {
      return state.user.userInfo.rights.api_list['share/saveResource'].has_right
    }
    return 1;
  },
  // 创建/修改发布
  right__link: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['link']) {
      return state.user.userInfo.rights.api_list['link'].has_right
    }
    return 1;
  },
  // 删除发布
  right__link_delete: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['link/delete']) {
      return state.user.userInfo.rights.api_list['link/delete'].has_right
    }
    return 1;
  },
  // 公开图像上传
  right__publicFileUpload: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['publicFileUpload']) {
      return state.user.userInfo.rights.api_list['publicFileUpload'].has_right
    }
    return 1;
  },
  // 预览历史版本
  right__file_version_back_preview: state => {
    if (has_all_right && state.user.userInfo.rights.api_list && state.user.userInfo.rights.api_list['file_version_back/preview']) {
      return state.user.userInfo.rights.api_list['file_version_back/preview'].has_right
    }
    return 1;
  },
}

export default getters